var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 15,
    viewBox: "0 0 5 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.40266 0.115478C3.31478 0.115478 4.0542 0.854899 4.0542 1.76702C4.0542 2.67914 3.31478 3.41856 2.40266 3.41856C1.49053 3.41856 0.751114 2.67914 0.751114 1.76702C0.751114 0.854899 1.49053 0.115478 2.40266 0.115478ZM2.40266 5.89588C3.31478 5.89588 4.0542 6.6353 4.0542 7.54742C4.0542 8.45954 3.31478 9.19896 2.40266 9.19896C1.49053 9.19896 0.751114 8.45954 0.751114 7.54742C0.751114 6.6353 1.49053 5.89588 2.40266 5.89588ZM2.40266 11.6763C3.31478 11.6763 4.0542 12.4157 4.0542 13.3278C4.0542 14.2399 3.31478 14.9794 2.40266 14.9794C1.49053 14.9794 0.751113 14.2399 0.751113 13.3278C0.751113 12.4157 1.49053 11.6763 2.40266 11.6763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.f0a814fd027cf82b196128cd1b046f1e.svg";
export { ForwardRef as ReactComponent };